import Button from "../../components/Button";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  Link,
} from "react-router-dom";
import { GoLog } from "react-icons/go";
import { ImListNumbered } from "react-icons/im";
import { MdOutlineSettings } from "react-icons/md";
import { MdOutlineLightMode } from "react-icons/md";
import { RiWaterPercentFill } from "react-icons/ri";
import { useStore } from "../../store";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { icon_menu_recipe } from "../../assets";
import config from "../../config";

function Menu() {
  const navigate = useNavigate();
  const { dataStore } = useStore();
  const resData = toJS(dataStore).resData;

  let onClickNav = function (path: string) {
    navigate("/" + path);
  };

  let onClickOnHumidity = function () {
    dataStore.sendData({
      action: "updateSetting",
      data: {
        key: "humidityEnabled",
        value: !resData.loadSettingAck?.humidityEnabled
      },
    });
  }

  return (
    <div className="flex bg-quickStartPrimaryBgColor">
      <div className="absolute w-[1280px] h-[730px] flex">
        <div className="w-1/5 relative">
          <Button
            options={{
              text: "HOME",
              class:
                "bg-buttonRunBgColor text-4xl px-8 absolute inset-0 m-auto",
              cb: () => navigate("/"),
            }}
            style={{
              padding: "0px 40px",
              boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
              backgroundColor: "#406F70",
              marginLeft: "55px",
            }}
          />
        </div>

        <div className="w-4/5 relative">
          <div className="border-4 rounded-2xl bg-[#406F70] absolute inset-0 m-auto w-10/12 h-5/6">


            <div
              className="float-left w-1/3 h-1/3 border-2 border-solid border-t-0 border-l-0"
              style={{
                boxShadow: resData.loadSettingAck?.humidityEnabled ? 'inset 0px 0px 30px #000' : 'none',
                borderTopLeftRadius: resData.loadSettingAck?.humidityEnabled ? "13px" : 'none'
              }}

              onClick={() => onClickOnHumidity()}
            >

              <div style={{
                "position": "absolute",
                left: 0,
                marginLeft: 180,
                marginTop: 30,
                lineHeight: 1.8,




              }}>

                <span style={{
                  fontWeight: 'bold',
                  color: resData.loadSettingAck?.humidityEnabled ? "white" : "#a7a7a7",

                }} >ON</span>
                <br />
                <span style={{
                  fontWeight: 'bold',
                  color: !resData.loadSettingAck?.humidityEnabled ? "white" : "#a7a7a7",

                }} >OFF</span>
              </div>

              <RiWaterPercentFill
                className="m-auto mt-10"
                style={{
                  color: "white",
                  fontSize: 80,
                  padding: 5,
                }}
              ></RiWaterPercentFill>

              <div className="text-center text-white text-2xl mt-2">Humidity Sensor</div>
            </div>

            <div
              className="float-left w-1/3 h-1/3 border-2 border-solid border-t-0 border-l-0"
              onClick={() => onClickNav("menu-log")}
            >
              <GoLog
                className="m-auto mt-10"
                style={{
                  color: "white",
                  fontSize: 80,
                  padding: 5,
                }}
              ></GoLog>
              <div className="text-center text-white text-2xl mt-2">Logs</div>
            </div>

            <div
              className="float-left w-1/3 h-1/3 border-2 border-solid border-t-0 border-l-0 border-r-0"
              onClick={() => onClickNav("menu-program")}
            >
              <ImListNumbered
                className="m-auto mt-10"
                style={{
                  color: "white",
                  fontSize: 80,
                  padding: 5,
                }}
              ></ImListNumbered>
              <div className="text-center text-white text-2xl mt-2">
                Programs
              </div>
            </div>

            <div
              className="float-left w-1/3 h-1/3 border-2 border-solid border-t-0 border-l-0 "
              onClick={() => onClickNav("menu-setting")}
            >
              <MdOutlineSettings
                className="m-auto mt-10"
                style={{
                  color: "white",
                  fontSize: 80,
                  padding: 5,
                }}
              ></MdOutlineSettings>
              <div className="text-center text-white text-2xl mt-2">
                Settings
              </div>
            </div>

            <div
              className="float-left w-1/3 h-1/3 border-2 border-solid border-t-0 border-l-0"
              onClick={() => onClickNav("menu-light-setting")}
            >
              <MdOutlineLightMode
                className="m-auto mt-10"
                style={{
                  color: "white",
                  fontSize: 80,
                  padding: 5,
                }}
              />
              <div className="text-center text-white text-2xl mt-2">
                Light Settings
              </div>
            </div>


            {config.REACT_APP_SHOW_RECIP
              ? (
                <div
                  className="float-left w-1/3 h-1/3 border-2 border-solid border-t-0 border-l-0 border-r-0"
                  onClick={() => onClickNav("menu-recipe")}
                >

                  <img
                    className="m-auto mt-10"
                    src={icon_menu_recipe}
                    style={{
                      height: 80,
                      padding: 5,
                    }}
                  />
                  <div className="text-center text-white text-2xl mt-2">
                    Recipes
                  </div>
                </div>
              )
              : (
                <div
                  className="float-left w-1/3 h-1/3 border-2 border-solid border-t-0 border-l-0 border-r-0"
                />
              )
            }




            <div className="float-left w-1/3 h-1/3 border-2 border-solid border-t-0 border-l-0 border-y-0"></div>

            <div className="float-left w-1/3 h-1/3 border-2 border-solid  border-l-0 border-y-0"></div>


          </div>
        </div>
      </div>
    </div>
  );
}
export default observer(Menu);
